import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import AppPage from '../views/AppPage/'
import Pagination from "react-js-pagination";
import $ from 'jquery';

class Announcements extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			 idd : '',
			aname : null,
			adesc : null,
			adate : null,
			aupname : null,
			aupdesc : null,
			aupdate : null,
			_message : '',
			currentPage: 1,
			todosPerPage: 20,
			activePage : 1,
			//value : '',
			alertClass :'',
			//_redirect : false,
			posts: []
		}
		this.basestate = this.state;
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onupdateSubmit = this.onupdateSubmit.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		///this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	
	onShowChange(e){
		this.state.todosPerPage = e.target.value;
		
			
			this.getdata();
		
	}
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onClick(e){
		
		document.getElementById("annform").reset();
	}
	
	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('announcement/removeannouncement',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Announcement Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Announcement',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	/* set value to react select 
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}*/
	onBack(){
		
		this.setState({idd : ''});
		
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.getanndata();
		
	}
	
	getanndata(){
		$("#showLoader").show();
		GetData('announcement/getannouncementsbyid/'+this.state.idd).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					aname : res[0]['title'],
					adesc : res[0]['content'],
					adate : res[0]['dateon']
				});
			}
		});
	}
	
	onupdateSubmit(e){
		e.preventDefault();
		
		if(this.state.idd){
			$("#showLoader").show();
			PostData('announcement/updateannouncement',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Announcement Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
					this.getdata();
				}
			});
		
		}
	
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.adate){
			$("#showLoader").show();
			PostData('announcement/saveannouncement',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Announcement Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("annform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
					document.getElementById("annform").reset();
					this.getdata();
				}
			});
		
		}
	
	}
	
	componentWillMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('announcement/getannouncements').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
				//$('#show option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	
  render() {
	  
	/*if(this.state._redirect){
		  
		return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

	}*/
	
	/** set showcount select box **/
	this.shows = [
		{value : '10', name : '10'},
		{value : '20', name : '20'},
		{value : '50', name : '50'},
		{value : '100', name : '100'}
	];
	
	if(this.state.idd!=''){
		
		$("#editann").show();
		$("#addann").hide();
	}
	else{
		
		$("#editann").hide();
		$("#addann").show();
	}
	
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.posts.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
	  return <tr key = {item}>
								<td width="20">{i+1}</td>
								<td width="100">{item.title}</td>
								<td width="30">
									<button name="editann" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
									&nbsp;&nbsp;
									<button name="removeann" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>;
	});
	
    return (
		<div>
		  <AppPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="5" id="addann">
					<Card>
					  <form action="" method="post" role="form" id="annform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Add Announcement</strong>
							
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Title<span className="text-danger">*</span></Label>
								  <Input type="text" name="aname" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Description<span className="text-danger">*</span></Label>
								  <Input type="textarea" name="adesc" rows="5" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">End Date<span className="text-danger">*</span></Label>
								  <Input type="date" name="adate" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				  <Col md="5" id="editann">
					<Card>
					  <form action="" method="post" role="form" id="annupform" encType="multipart/form-data" onSubmit={this.onupdateSubmit} >
						<CardHeader>
							<strong>Update Announcement</strong>
							<Button outline color="primary" className="btn-right" onClick={this.onBack}>Add</Button>
						</CardHeader>
						<CardBody>
							<Row>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Title<span className="text-danger">*</span></Label>
								  <Input type="text" name="aname" required onChange={this.onChange} value={this.state.aname} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Description<span className="text-danger">*</span></Label>
								  <Input type="textarea" name="adesc" rows="5" required onChange={this.onChange} value={this.state.adesc} />
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">End Date<span className="text-danger">*</span></Label>
								  <Input type="date" name="adate" required onChange={this.onChange} value={this.state.adate} />
								</FormGroup>
							  </Col>
							  
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				 <Col md="7">
				   <Card>
					<CardBody>
					<select name="show" onChange={this.onShowChange} id="show" >
									{this.shows.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>&nbsp;
							entries
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Title</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{renderTodos}
							<br></br>
							<Pagination
								 activePage={this.state.activePage}
								 itemsCountPerPage={this.state.todosPerPage}
								 pageRangeDisplayed={3}
								 totalItemsCount={this.state.posts.length}
								 onChange={this.handlePageChange}
								/>
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Announcements;


// WEBPACK FOOTER //
// ./src/Announcements/Announcements.js